/** @format */

"use client";
import "./NavBar.css";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { Snackbar } from "@mui/material";
import { apiService } from "@/services/api.services";
import CustomButton from "../Buttons/CustomButton";
import BurgerMenu from "./BurgerMenu";
import logo1 from "@/Helper/images/new/logo.svg";
const NavBar = () => {
  const pathname = usePathname();

  console.log("Current Pathname:", pathname);

  const [isOnScroll, setIsOnScroll] = useState(false);
  const [logo, setLogo] = useState(null);
  const [isOpen, setisOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  useEffect(() => {
    apiService.getAllUtilityData().then((resp) => {
      if (resp.status === 200) {
        setLogo(`${resp.data?.data?.attributes?.logo?.data?.attributes?.url}`);
      }
    });
  }, []);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };
  const toggleSubMenu = (event) => {
    event.stopPropagation();
    setIsSubMenuOpen(!isSubMenuOpen);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".withsubmenunav") &&
        !event.target.closest(".list_submenu")
      ) {
        setActiveDropdown(null);
        setIsSubMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setIsOnScroll(true);
      } else {
        setIsOnScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ProductsDropdown = () => (
    <ul className="nav_subulweb nav_subul ProductsDropdown">
      <li>
        <Link
          href={"/custom-shaft-design"}
          key={"custom-shaft-design"}
          aria-label={`Custom shaft design `}
        >
          <p className="navbar_desktop">
            <span
              className={
                "# " !== "/"
                  ? pathname.includes("#")
                    ? "currentPage"
                    : ""
                  : pathname === "#"
                  ? "currentPage"
                  : ""
              }
            >
              Custom shaft design
            </span>
          </p>
        </Link>
      </li>

      <li
        className={`list_submenu ${isSubMenuOpen ? "submenu_open" : ""}`}
        onClick={toggleSubMenu}
      >
        <p className="navbar_desktop">
          <span
            className={
              "/ready-flex-shaft" !== "/"
                ? pathname.includes("/ready-flex-shaft")
                  ? "currentPage"
                  : ""
                : pathname === "/ready-flex-shaft"
                ? "currentPage"
                : ""
            }
          >  Ready-flex product line
            {" "}
            <svg class="droparrow-icon"
              width="5"
              height="10"
            
              viewBox="0 0 5 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0L0 10L5 5L0 0Z" fill="CurrentColor" />
            </svg>
          </span>
        </p>

        <ul
          className={`drop_submenu ${isSubMenuOpen ? "show_submenu" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <li>
            <Link
              href={"/standard-flexible-shaft"}
              key={"standard flexible shaft"}
              aria-label={` Standard flexible shaft`}
              passHref
              onClick={() => setActiveDropdown(null)}
            >
              <p className="navbar_desktop">
                <span
                  className={
                    "/standard-flexible-shaft" !== "/"
                      ? pathname.includes("/standard-flexible-shaft")
                        ? "currentPage"
                        : ""
                      : pathname === "/standard-flexible-shaft"
                      ? "currentPage"
                      : ""
                  }
                >
                  Standard flexible shaft
                </span>
              </p>
            </Link>
          </li>
          <li>
            <Link
              href={"/ready-flex-product-line"}
              key={"ready-flex-product-line"}
              aria-label={`Ready-flex shaft`}
              onClick={() => setActiveDropdown(null)}
            >
              <p className="navbar_desktop">
                <span
                  className={
                    "/ready-flex-product-line" !== "/"
                      ? pathname.includes("/ready-flex-product-line")
                        ? "currentPage"
                        : ""
                      : pathname === "/ready-flex-product-line"
                      ? "currentPage"
                      : ""
                  }
                >
                Ready-flex shaft
                </span>
              </p>
            </Link>
          </li>
          <li>
            <Link
              href={"/ready-flex-configurator"}
              key={"ready-flex-configurator"}
              aria-label={`  Ready-flex configurator`}
            >
              <p className="navbar_desktop">
                <span
                  className={
                    "/ready-flex-configurator" !== "/"
                      ? pathname.includes("/ready-flex-configurator")
                        ? "currentPage"
                        : ""
                      : pathname === "/ready-flex-configurator"
                      ? "currentPage"
                      : ""
                  }
                >
                  Ready-flex configurator
                </span>
              </p>
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link href={"/gear-boxes"} key={"gear-boxes"} aria-label={`Gear boxes`}>
          <p className="navbar_desktop">
            <span
              className={
                "/gear-boxes" !== "/"
                  ? pathname.includes("/gear-boxes")
                    ? "currentPage"
                    : ""
                  : pathname === "/gear-boxes"
                  ? "currentPage"
                  : ""
              }
            >
              Gear boxes
            </span>
          </p>
        </Link>
      </li>
    </ul>
  );
  const ApplicationsDropdown = () => (
    <ul className="nav_subulweb nav_subul ApplicationsDropdown">
       
      <li>
        <Link href={"/aerospace"} key={"aerospace"} aria-label={`Aerospace`}>
          <p className="navbar_desktop">
            <span
              className={
                "/aerospace" !== "/"
                  ? pathname.includes("/aerospace")
                    ? "currentPage"
                    : ""
                  : pathname === "/aerospace"
                  ? "currentPage"
                  : ""
              }
            >
              Aerospace
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/automotive"} key={"automotive"} aria-label={`Automotive`}>
          <p className="navbar_desktop">
            <span
              className={
                "/automotive" !== "/"
                  ? pathname.includes("/automotive")
                    ? "currentPage"
                    : ""
                  : pathname === "/automotive"
                  ? "currentPage"
                  : ""
              }
            >
              Automotive
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/medical"} key={"Medical"} aria-label={`Medical`}>
          <p className="navbar_desktop">
            <span
              className={
                "/medical" !== "/"
                  ? pathname.includes("/medical")
                    ? "currentPage"
                    : ""
                  : pathname === "/medical"
                  ? "currentPage"
                  : ""
              }
            >
              Medical
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/industrial"} key={"Industrial"} aria-label={`Industrial`}>
          <p className="navbar_desktop">
            <span
              className={
                "/industrial" !== "/"
                  ? pathname.includes("/industrial")
                    ? "currentPage"
                    : ""
                  : pathname === "/industrial"
                  ? "currentPage"
                  : ""
              }
            >
              Industrial
            </span>
          </p>
        </Link>
      </li>
    </ul>
  );
  const AboutUsDropdown = () => (
    <ul className="nav_subulweb nav_subul AboutUsDropdown">
      <li>
        <Link href={"/about-us"} key={"About Us"} aria-label={`About Us`}>
          <p className="navbar_desktop">
            <span
              className={
                "/about-us" !== "/"
                  ? pathname.includes("/about-us")
                    ? "currentPage"
                    : ""
                  : pathname === "/about-us"
                  ? "currentPage"
                  : ""
              }
            >
              About Us
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/quality"} key={"Quality"} aria-label={`Quality`}>
          <p className="navbar_desktop">
            <span
              className={
                "/quality" !== "/"
                  ? pathname.includes("/quality")
                    ? "currentPage"
                    : ""
                  : pathname === "/quality"
                  ? "currentPage"
                  : ""
              }
            >
              Quality
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/gallery"} key={"Gallery"} aria-label={`Gallery`}>
          <p className="navbar_desktop">
            <span
              className={
                "/gallery" !== "/"
                  ? pathname.includes("/gallery")
                    ? "currentPage"
                    : ""
                  : pathname === "/gallery"
                  ? "currentPage"
                  : ""
              }
            >
              Gallery
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/team"} key={"Team"} aria-label={`Team`}>
          <p className="navbar_desktop">
            <span
              className={
                "/team" !== "/"
                  ? pathname.includes("/team")
                    ? "currentPage"
                    : ""
                  : pathname === "/team"
                  ? "currentPage"
                  : ""
              }
            >
              Team
            </span>
          </p>
        </Link>
      </li>
      <li>
        <Link href={"/history"} key={"History"} aria-label={`History`}>
          <p className="navbar_desktop">
            <span
              className={
                "/history" !== "/"
                  ? pathname.includes("/history")
                    ? "currentPage"
                    : ""
                  : pathname === "/history"
                  ? "currentPage"
                  : ""
              }
            >
              History
            </span>
          </p>
        </Link>
      </li>
      {/* <li>
        <Link
          href={"/testimonials"}
          key={"Testimonials"}
          aria-label={`Testimonials`}
        >
          <p className="navbar_desktop">
            <span
              className={
                "/testimonials" !== "/"
                  ? pathname.includes("/testimonials")
                    ? "currentPage"
                    : ""
                  : pathname === "/testimonials"
                  ? "currentPage"
                  : ""
              }
            >
              Testimonials
            </span>
          </p>
        </Link>
      </li> */}
      <li>
        <Link href={"/careers"} key={"Careers"} aria-label={`Careers`}>
          <p className="navbar_desktop">
            <span
              className={
                "/careers" !== "/"
                  ? pathname.includes("/careers")
                    ? "currentPage"
                    : ""
                  : pathname === "/careers"
                  ? "currentPage"
                  : ""
              }
            >
              Careers
            </span>
          </p>
        </Link>
      </li>
    </ul>
  );

  const ResourcesDropdown = () => (
    <ul className="nav_subulweb nav_subul ResourcesDropdown">
      <div>
        <li>
          <Link href={"/blog"} key={"blog"} aria-label={`blog`}>
            <p className="navbar_desktop">
              <span
                className={
                  "/blog" !== "/"
                    ? pathname.includes("/blog")
                      ? "currentPage"
                      : ""
                    : pathname === "/blog"
                    ? "currentPage"
                    : ""
                }
              >
                Blog
              </span>
            </p>
          </Link>
        </li>

        <li>
          <Link href={"/technical"} key={"technical"} aria-label={`technical`}>
            <p className="navbar_desktop">
              <span
                className={
                  "/technical" !== "/"
                    ? pathname.includes("/technical")
                      ? "currentPage"
                      : ""
                    : pathname === "/technical"
                    ? "currentPage"
                    : ""
                }
              >
                Technical
              </span>
            </p>
          </Link>
        </li>

        <li>
          <Link href={"/use-cases"} key={"usecase"} aria-label={`usecase`}>
            <p className="navbar_desktop">
              <span
                className={
                  "/use-cases" !== "/"
                    ? pathname.includes("/use-cases")
                      ? "currentPage"
                      : ""
                    : pathname === "/use-cases"
                    ? "currentPage"
                    : ""
                }
              >
                Usecase
              </span>
            </p>
          </Link>
        </li>
      </div>
    </ul>
  );

  return (
    <div
      className={`nav_area ${isOnScroll ? "onscroll_bg" : ""}  ${
        pathname === "/" ||
        pathname === "/standard-flexible-shaft" ||
        pathname === "/aerospace" ||
        pathname === "/automotive" ||
        pathname === "/industrial" ||
        pathname === "/medical"
          ? "nav_area_home"
          : "nav_area_blog"
      }`}
    >
      <Snackbar
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        open={isOpen}
        autoHideDuration={3000}
        onClose={() => setisOpen(false)}
        message="Coming Soon!"
      />
      <div className="container">
        <nav className=" nav_container ">
          <div className="nav_container_left">
            <Link href={"/"} key={"logo"}>
              <Image src={logo1} alt="logo" className="nav_logo" height={51} />
            </Link>
          </div>
          <div className="nav_container_right">
            <div className="nav_container_right_inner nav_container_right_innermenu">
              <Link href={"/"} key={"home"} aria-label={`home`}>
                <p className="navbar_desktop">
                  <span
                    className={
                      "/" !== "/"
                        ? pathname.includes("/")
                          ? "currentPage"
                          : ""
                        : pathname === "/"
                        ? "currentPage"
                        : ""
                    }
                  >
                    Home
                  </span>
                </p>
              </Link>
              <div
                className={`navbar_desktop withsubmenunav ${
                  activeDropdown === "Products" ? "selectedmenu" : ""
                }`}
                onClick={() => toggleDropdown("Products")}
              >
                <span className="mainspan">Products</span>

                {activeDropdown === "Products" && <ProductsDropdown />}
              </div>
              <div
                className={`navbar_desktop withsubmenunav ${
                  activeDropdown === "Applications" ? "selectedmenu" : ""
                }`}
                onClick={() => toggleDropdown("Applications")}
              >
                <span className="mainspan">Applications</span>
                {activeDropdown === "Applications" && <ApplicationsDropdown />}
              </div>

              <div
                className={`navbar_desktop withsubmenunav ${
                  activeDropdown === "Resources" ? "selectedmenu" : ""
                }`}
                onClick={() => toggleDropdown("Resources")}
              >
                <span
                  className={`mainspan ${
                    pathname.includes("/blog") ? "currentPage" : ""
                  }`}
                >
                  Resources
                </span>

                {activeDropdown === "Resources" && <ResourcesDropdown />}
              </div>
              <div
                className={`navbar_desktop withsubmenunav ${
                  activeDropdown === "About Us" ? "selectedmenu" : ""
                }`}
                onClick={() => toggleDropdown("About Us")}
              >
                <span className="mainspan">About Us</span>

                {activeDropdown === "About Us" && <AboutUsDropdown />}
              </div>
              {/* <Link href={"/blog"} key={"blog"} aria-label={`blog`}>
                <p className="navbar_desktop">
                  <span
                    className={
                      "/blog" !== "/"
                        ? pathname.includes("/blog")
                          ? "currentPage"
                          : ""
                        : pathname === "/blog"
                        ? "currentPage"
                        : ""
                    }
                  >
                    Blog
                  </span>
                </p>
              </Link> */}
            </div>

            <div className="nav_container_right_inner">
              <Link aria-label="Contact Us" href={"/contact-us"}>
                <CustomButton
                  Text={"Contact Us"}
                  PrimaryColorBtn
                  navBar
                  className="navbar_desktop"
                />
              </Link>
            </div>
          </div>
        </nav>
        <BurgerMenu pathname={pathname} />
      </div>
    </div>
  );
};

export default NavBar;
